import React, { Component } from 'react';
import { PrimaryButton, DefaultButton} from 'office-ui-fabric-react/lib/Button';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import {
    Spinner,
    SpinnerSize
  } from 'office-ui-fabric-react/lib/Spinner';
  import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ImageWithMarker} from './ImageWithMarker';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import * as outlookItemActions  from '../actions/outlookItemActions';
import * as roomMapActions  from '../actions/roomMapActions';
import * as personMapActions  from '../actions/personMapActions';
import './MapDisplay.css';

import { getRecipients} from '../store/configureStore';

const Office = window.Office;

console.log('-----------------------');
console.dir(Office);

var item;
var dialog;

class MapDisplay extends Component {
  displayName = MapDisplay.name

  constructor(props) {
    super(props);

    this._closeDialog = this._closeDialog.bind(this);

    this.state = {
        timer: null,
        roomName: '',
        timerStarted: false,
        markerTop: -1,
        markerLeft: -1,
        hideDialog: true,
        appointment: true, //false if message
        readOnlyAppointment: true,
        recipients: [],

        divStyle: {
            width: '600px'
          },
          poweredByStyle: {
              fontColor: 'red'
          }

        };
    }
    
    componentWillMount =  () => { 
        item = Office.context.mailbox.item;
        
        // get info of type (appointment/message) and if readonly or compose
        this.props.combinedActions.checkType();
    }

    componentWillUnmount() {
       clearInterval(this.state.timer);
    }

    tick = () => {
        this.getLocationOrRecipients();
    }

    getLocationOrRecipients() {
        if (this.props.outlookItem.type === Office.MailboxEnums.ItemType.Appointment) {
            // if meeting - try to read location from meeting
            this.props.combinedActions.fetchLocation();
        }
        else {
            // if message then read the recipients
            this.props.combinedActions.fetchRecipients();
        }
    }


    componentWillReceiveProps(nextProps) {
        if(nextProps.userReg.exchangeToken !== this.props.userReg.exchangeToken ) {
            console.log('Receiving new exchange token:' + nextProps.userReg.exchangeToken);
            if(!this.state.timerStarted) {
                this.setState({ timerStarted: true })
                
                this.getLocationOrRecipients();
                
                let timer = setInterval(this.tick, 1000);
                this.setState({timer});
                console.log('location timer started.');
            }

            // try to get map immiediately after getting exchange token
            if(nextProps.outlookItem.location) {
                this.props.combinedActions.fetchRoomMap(nextProps.outlookItem.location);
            }

            // if we got a sender (when type == message) then set this as person to show map for
            if(this.props.outlookItem.type === Office.MailboxEnums.ItemType.Message && nextProps.recipients) {
                const sender = nextProps.recipients.find( r => { return  r.hasOwnProperty('sender') }); 
                if(sender) {
                    this.props.combinedActions.personSelect(sender.emailAddress, sender.displayName);
    
                    //this.props.combinedActions.fetchPersonMap(newSender.email);
                }
            }
        } // end new exchangeToken
        
        if(nextProps.outlookItem.location !== this.props.outlookItem.location && nextProps.userReg.exchangeToken && nextProps.outlookItem.location) {
            this.props.combinedActions.fetchRoomMap(nextProps.outlookItem.location);
        }

        if(nextProps.personMap.selectedUser !== this.props.personMap.selectedUser && nextProps.userReg.exchangeToken ) {
            this.props.combinedActions.fetchPersonMap(nextProps.personMap.selectedUser.emailAddress, nextProps.personMap.selectedUser.displayName);
        }

        // try to set selected user to sender as soon as we got the list of recipients
        if(!(nextProps.personMap.selectedUser && nextProps.personMap.selectedUser.emailAddress) && nextProps.userReg.exchangeToken  &&  nextProps.recipients && nextProps.recipients.length > 0) {
            const sender = nextProps.recipients.find( r => { return  r.hasOwnProperty('sender') }); 
            if(sender) {
                this.props.combinedActions.personSelect(sender.emailAddress, sender.displayName);
            }
        }
    }
    

     _showDialog = () => {
        dialog = null;
        let url = this._getAbsoluteUrl('large?roomName=' + encodeURIComponent(this.props.outlookItem.location) + '&mapTitle=' + encodeURIComponent(this.props.roomMap.mapTitle) + '&roomImage=' + encodeURIComponent(this.props.roomMap.largeUrl) + '&x=' + this.props.roomMap.location.x + '&y=' + this.props.roomMap.location.y);
        let dialogOptions = { width: 80, height: 80, displayInIframe: true };
        Office.context.ui.displayDialogAsync(url, dialogOptions, function (result) {
            dialog = result.value;
            
        });
      }
    
    _closeDialog() {
        console.log('Dialog closed');
        dialog = null;
      }
    
     _getAbsoluteUrl = (function() {
        var a;

        return  (url) => {
            if (!a) a = document.createElement('a');
            a.href = url;

            return a.href;
        };
    })();
        
    _insertMap = () => {
        
        item.body.getTypeAsync(
             (result) => {
                if (result.status === Office.AsyncResultStatus.Failed){
                    console.log("Error calling item.body.getTypeAsync: " + result.error.message);
                }
                else {
                    // Successfully got the type of item body.
                    // Set data of the appropriate type in body.
                    if (result.value === Office.MailboxEnums.BodyType.Html) {
                        // Body is of HTML type.
                        // Specify HTML in the coercionType parameter
                        // of setSelectedDataAsync.
                        let tenantId = this.props.license.tenantId;
                        let roomName = this.props.outlookItem.location;
                        let imageWidth = 310; 
                       // let imageHeight = document.getElementById("imageRef").height;

                        let htmlToInsert = '<table cellpadding="0" cellspacing="0" border="0" width="' + imageWidth + '" >';
                        htmlToInsert += '<tr><td style="text-align: center; font-size: x-large">' + this.props.roomMap.mapTitle + '</td></tr>';
                        htmlToInsert += '<tr><td valign="top">';
                        htmlToInsert += '<img alt="' + roomName + '" src="https://api.meetingroommap.net/api/mapimage/' + tenantId + '/' + roomName + '"/>';
                        htmlToInsert += '</td></tr>';

                       // check list of tenantIds to not display footer
                        const tenantIdsWithoutFooter = [
                            "adf1e1f5-5c6e-450e-a168-8f4de1d6740b",  // amwins.com
                            "a0eb96fc-9414-4aea-ba02-50695130386d",  // M365x02419567.onmicrosoft.com
                            "e15ad8aa-7bf5-4dbe-b68d-f9460ea20eb3"   // M365B046383.onmicrosoft.com
                            ];

                        if (tenantIdsWithoutFooter.indexOf(tenantId) >= 0) {
                            console.log('skipping footer for tenantid:' + tenantId);
                        }
                        else {
                            htmlToInsert += '<tr><td style="text-align: center; font-size: xx-small">Powered by <a target="_blank" href="https://www.meetingroommap.net" >www.MeetingRoomMap.net</a></td></tr>';
                        }
                        
                        htmlToInsert += '</table>';
                        
                        console.log(htmlToInsert);
                        item.body.setSelectedDataAsync(
                            htmlToInsert,
                            { coercionType: Office.CoercionType.Html, 
                            asyncContext: { } },
                            function (asyncResult) {
                                if (asyncResult.status === Office.AsyncResultStatus.Failed){
                                        console.log("Error calling item.body.setSelectedDataAsync: " + asyncResult.error.message);
                                }
                                else {
                                    // Successfully set data in item body.
                                }
                            });
                    }
                    else {
                        // Body is of text type. 
                        item.body.setSelectedDataAsync(
                            'Body is of type text - switch to HTML mode to be able to insert MeetingRoomMap...',
                            { coercionType: Office.CoercionType.Text, 
                                asyncContext: { var3: 1, var4: 2 } },
                            function (asyncResult) {
                                if (asyncResult.status === Office.AsyncResultStatus.Failed){
                                        console.log("Error calling item.body.setSelectedDataAsync: " + asyncResult.error.message);
                                }
                                else {
                                    // Successfully set data in item body.
                                    // Do whatever appropriate for your scenario,
                                    // using the arguments var3 and var4 as applicable.
                                }
                             });
                    }
                }
            });

      }
      render2() {
        const recipients = this.props.recipients.map((r) => {
            return (r.displayName + ' - ' + r.emailAddress + ' sender:' + r.sender );
          });
          const sender = this.props.recipients.find( r => { return  r.hasOwnProperty('sender') }); 
            
        return <div>        
            type: {this.props.outlookItem.type}<br/>
            readOnly: {this.props.outlookItem.readOnly.toString()}<br/>
            location: {this.props.outlookItem.location}<br/>
            recipients: {recipients}<br/>
            
        </div>;
    };

      
    
      render() {
        
        if (this.props.hasErrored) {
            return <div>        
                <h3>Ooops - we have an error: {this.props.errMsg}</h3>
            </div>;
        }

        if (this.props.isLoading || this.props.personMap.isLoading) {
           const location = (this.props.outlookItem.type === Office.MailboxEnums.ItemType.Appointment)?(this.props.outlookItem.location):(this.props.personMap.selectedUser.displayName);
            return <div>        
            <Spinner size={ SpinnerSize.large } label= {'Finding map for ' + location +'...'} ariaLive='assertive' />
        </div>;
        }

        if(this.props.outlookItem.type === Office.MailboxEnums.ItemType.Appointment) {
            if(  !this.props.outlookItem.location) {
                return <div>        
                    <h3>No room selected - add a room to the meeting...</h3>
                    <p>
                        No room is currently assigned to this meeting. This add-in reads the current meeting room, and shows the map if this meeting room has been assigned to a map. 
                    </p>
                    <p>
                    Use the settings link (<Icon iconName='Settings' className='ms-fontColor-neutralPrimary' />)  in the bottom to create mappings between a room and a map.
                    </p>
                </div>;
            }

            if ( !this.props.roomMap.mapTitle) {
                return <div>        
                <h3>Couldn't find any maps for room '{this.props.outlookItem.location}'.  </h3>
                <p>Make sure this room is attached to a map. 
                Use the settings link (<Icon iconName='Settings' className='ms-fontColor-neutralPrimary' />)  in the bottom to create mappings between a room and a map. 
                </p>
                </div>;
            }

        }
        else{
            if( !this.props.personMap.selectedUser.displayName) {
                return <div>        
                    <Dropdown
                            label='Select user from mail to display map for:'
                            id='Basicdrop1'
                            ariaLabel='Basic dropdown example'
                            selectedKey={ this.props.personMap.selectedUser && this.props.personMap.selectedUser.emailAddress }
                            onChanged={ (item) => this.props.combinedActions.personSelect(item.key, item.text ) }
                            options={this.props.recipients.map((r) => {
                                return ( {
                                    key: r.emailAddress,
                                    text: r.displayName
                                })
                              })}
                            />
                </div>;
            }

            
            if ( !this.props.personMap.mapTitle) {
                return <div>       
                       <Dropdown
                            label='Select user from mail to display map for:'
                            id='Basicdrop1'
                            ariaLabel='Basic dropdown example'
                            selectedKey={ this.props.personMap.selectedUser && this.props.personMap.selectedUser.emailAddress }
                            onChanged={ (item) => this.props.combinedActions.personSelect(item.key, item.text ) }
                            options={this.props.recipients.map((r) => {
                                return ( {
                                    key: r.emailAddress,
                                    text: r.displayName
                                })
                              })}
                            /> 
                            <div>&nbsp;</div>
                <h3>Couldn't find map for '{this.props.personMap.selectedUser.displayName}'.  </h3>
                <p>Make sure this user is present in your Azure AD, has an officeLocation set and this location is attached to a map. 
               Go to <a href="https://www.meetingroommap.net/Person">https://www.meetingroommap.net/Person</a> to create mappings between a person and a map. 
                </p>
                </div>;
            }
        }

        return <div>
            <span className="ms-font-xxl ms-fontWeight-semibold">{this.props.roomMap.mapTitle}</span>

                <div id="container" >
                    <ImageWithMarker url={this.props.roomMap.thumbnailUrl} markerX={this.props.roomMap.location.x} markerY={this.props.roomMap.location.y}/>
                    <PrimaryButton onClick={ this._showDialog.bind(this._showDialog) }>Show large image</PrimaryButton>&nbsp;
                    {!this.props.outlookItem.readOnly && <DefaultButton onClick={ this._insertMap.bind(this._insertMap) }>Insert map</DefaultButton>}       
                </div>
      </div>
        
    }
    
}



MapDisplay.propTypes = {
    outlookItemActions: PropTypes.object,
    personMapActions: PropTypes.object,
    roomMapActions: PropTypes.object,
    roomMap: PropTypes.object
};
  
  function mapStateToProps(state) {
    return {
      roomMap: state.roomMap,
      isLoading: state.roomMapIsLoading,
      hasErrored: state.roomMapHasErrored.hasErrored,
      errMsg: state.roomMapHasErrored.errMsg,

      outlookItem: state.outlookItem,
      recipients: getRecipients(state),

      personMap: state.personMap,

      userReg: state.userRegTokens,
      license: state.userRegLicense,
    };
  }
  
  function mapDispatchToProps(dispatch) {
    return {
        combinedActions: bindActionCreators(Object.assign({}, roomMapActions, personMapActions, outlookItemActions), dispatch),
    };
  }


  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(MapDisplay);